/**
 * แสดงวันที่และเวลา แบบเดียวกับ format การแจ้งเตือน (Notifications)
 * ใช้ th-TH locale รูปแบบ: วัน เดือน ปี เวลา
 */
export const formatDate = (dateString) => {
  if (dateString == null || dateString === '') return '-';
  try {
    return new Date(dateString).toLocaleString('th-TH', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Asia/Bangkok',
    });
  } catch (_) {
    return String(dateString);
  }
};
